import { IconName, IconSize, PalmettoIcon } from '@palmetto/dsm-components';
import { useEffect, useState } from 'react';

export interface CyclingIconsProps {
  iconNames: IconName[];
  speed: number;
  size?: IconSize;
  className?: string;
}

export function CyclingIcons({ iconNames, speed, size = 'md', className }: CyclingIconsProps) {
  const [currentIconIndex, setCurrentIconIndex] = useState(0);

  useEffect(() => {
    if (iconNames.length === 0) return;

    const interval = setInterval(() => {
      setCurrentIconIndex((prevIndex) => (prevIndex + 1) % iconNames.length);
    }, speed);

    return () => clearInterval(interval);
  }, [iconNames, speed]);

  if (iconNames.length === 0) {
    return null;
  }

  return <PalmettoIcon name={iconNames[currentIconIndex]} size={size} className={className} />;
}

export default CyclingIcons;
